import { NavLink } from "react-router-dom";
import { Home, Dumbbell, TrendingUp, User } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/cn";

interface Tab {
  to: string;
  label: string;
  icon: LucideIcon;
  /** `end` força match exato (só a Home), senão prefixo (treinos/123 acende Treinos). */
  end?: boolean;
}

/** Navegação fixa inferior (mobile-first) — 4 abas, paridade com o legado. */
export function BottomNav({ slug }: { slug: string }) {
  const base = `/s/${slug}`;
  const tabs: Tab[] = [
    { to: base, label: "Início", icon: Home, end: true },
    { to: `${base}/treinos`, label: "Treinos", icon: Dumbbell },
    { to: `${base}/evolucao`, label: "Evolução", icon: TrendingUp },
    { to: `${base}/perfil`, label: "Perfil", icon: User },
  ];

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-20 border-t border-border-subtle bg-canvas/95 backdrop-blur"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="mx-auto flex max-w-lg items-stretch justify-around">
        {tabs.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center gap-1 py-2.5 text-xs transition-colors",
                  isActive ? "text-accent-soft" : "text-faint hover:text-muted",
                )
              }
            >
              {({ isActive }) => (
                <>
                  <tab.icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                  <span>{tab.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
